"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.notImplementedPresenter = void 0;
exports.notImplementedPresenter = {
    present: () => {
        throw new Error('Method not implemented');
    },
    presentPage: () => {
        throw new Error('Method not implemented');
    },
    presentFullPage: () => {
        throw new Error('Method not implemented');
    },
    dismissLatest: () => {
        throw new Error('Method not implemented');
    },
    dismissAll: () => {
        throw new Error('Method not implemented');
    }
};
//# sourceMappingURL=notImplementedPresenter.js.map